import moment from 'moment';
import { isActiveOrder, isRejectedOrder } from './order';

export function validEmail(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}

export function validDate(date) {
  const time = Date.parse(date);
  return !isNaN(time);
}

export function underage(birthday) {
  const date = new Date(birthday);
  return moment().diff(date, 'years') < 21;
}

export function formatBirthday(birthday) {
  const normalized = birthday.replace(/-/g, '/');
  const date = new Date(normalized);
  return moment(date).format('YYYY-MM-DD');
}

export function displayBirthday(birthday) {
  if (!birthday) return '';
  const normalized = birthday.replace(/-/g, '/');
  const date = new Date(normalized);
  return moment(date).format('MM/DD/YYYY');
}

export function activeOrder(user) {
  const order = user && user.orders && user.orders[0];
  if (!order) return null;
  return isActiveOrder(order) || isRejectedOrder(order) ? order : null;
}

export function latestOrder(user) {
  const order = user && user.orders && user.orders[0];
  return order || null;
}

export function getFBAvatar(user, large = false) {
  if (!user.fbID) return null;
  return `https://graph.facebook.com/${user.fbID}/picture?width=${
    large ? '100' : '50'
  }&height=${large ? '100' : '50'}&return_ssl_resources=1`;
}

export function fullName(user) {
  const firstName = user.firstname || '';
  const lastName = user.lastname || '';
  return [firstName, lastName].filter(name => !!name).join(' ');
}
